export function clearString(str: string) {
  return str.replace(/[^a-zA-Z0-9]/g, "");
}
